import { createContext, useContext, useEffect, useState } from 'react';
import { useRemote } from '../../../Utils/Utils';
import { useParams, useHistory } from 'react-router-dom';
import { PAGES, ROUTE_PATHS } from '../../../InternalApiApp';
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';
import { BannerContext } from '../../../InternalApiApp';
import { toastDanger, toastSuccess } from '../../../components/popups/Toast';
import Page, { PageContentBodyGrid } from '../../Shared/Page/Page';
import PageGridItem from '../../Shared/Page/PageGridItem';
import PageGridDivider from '../../Shared/Page/PageGridDivider';
import PageContentToggle from '../../../components/Menus/PageContentToggle';
import ActionButtonsBanner from '../../Shared/Banner/ActionButtonsBanner';
import FundGeneral from './FundTabs/FundGeneral';
import FundPersonnel from './FundTabs/FundPersonnel'
import FundFootnotes from './FundTabs/FundFootnotes'
import FundInvestmentMix from './FundTabs/FundInvestmentMix';
import FundHoldings from './FundTabs/FundHoldings';
import FundHoldingRationales from './FundTabs/FundHoldingRationales';
import FundPerformance from './FundTabs/FundPerformance';
import FundDisclaimers from './FundTabs/FundDisclaimers';
import LoadingIcon from '../../../components/LoadingIcon';
import FundTab from './FundTabs/FundTab';
import "./FundPage.scss"

export const FundContext = createContext();

const FundPage = ({ me, portfolio }) => {
    const { setBannerBreadCrumbs } = useContext(BannerContext);
    const { fundId } = useParams()
    const remote = useRemote()
    const history = useHistory()
    const identifier = btoa(fundId)

    const [originalFund, setOriginalFund] = useState(null)
    const [fund, setFund] = useState(null)
    const [editMode, setEditMode] = useState(false)
    const [selectedTab, setSelectedTab] = useState('General')
    const [notes, setNotes] = useState([])
    const [taggedNotesIds, setTaggedNotesIds] = useState([])
    const [taggedNotesToDelete, setTaggedNotesToDelete] = useState([])
    const [taggedNotes, setTaggedNotes] = useState([])
    const [templatesWithTaggedNotes, setTemplatesWithTaggedNotes] = useState([])
    const [holdings, setHoldings] = useState([])
    const [staticData, setStaticData] = useState([])
    const [originalStaticData, setOriginalStaticData] = useState([])
    const [config, setConfig] = useState()
    const [brand, setBrand] = useState(null)
    const [hierarchy, setHierarchy] = useState([])
    const [disclaimers, setDisclaimers] = useState([])
    const [originalDisclaimers, setOriginalDisclaimers] = useState([])
    const [disclaimersSelected, setDisclaimersSelected] = useState([])
    const [cancelledChanges, setCancelledChanges] = useState(false)
    const nonGeneralConfigGroups = config && config.filter(group => group.groupName !== "General")

    const linkStem = portfolio ? `${ROUTE_PATHS[PAGES.ADMIN]}/portfolio-management/portfolios/${fundId}` : `${ROUTE_PATHS[PAGES.ADMIN]}/fund-management/funds/${fundId}`

    useEffect(() => {
        remote.get(`/funds/funds/${fundId}`).then((fund) => {
            setBannerBreadCrumbs(portfolio ? { tab: 'Portfolios', param1: { name: fund.fundName, id: fundId } } : { tab: 'Funds', param1: { name: fund.fundName, id: fundId } })
            remote.get(`funds/portfolio/static-data/${fundId}`).then(res => {
                remote.get("funds/portfolio/config").then(resp => {
                    remote.get(`/funds/portfolio/dynamic/${fundId}/holdings`).then(fetchHoldings => {
                        setConfig(resp)
                        setOriginalStaticData(res)
                        setStaticData(res)
                        setHoldings(fetchHoldings)
                        setFund(fund)
                        setNotes(fund.disclosures)
                        setOriginalFund(fund)
                    })
                });
            });
        })
    }, [fundId])

    useEffect(() => {
        remote.get('/brand/default').then((brand) => {
            const defaultBrand = brand?.id || null;
            if (defaultBrand) {
                remote.get(`/brand/${defaultBrand}/details`).then(setBrand);
            }
        });

        remote.get(`funds/portfolio/groupings/hierarchy`).then(setHierarchy);

        remote.get(`/disclaimers/fund/${fundId}`).then(fetchedDisclaimers => {
            const selected = fetchedDisclaimers.filter(d => d.selected).map(d => d.id)
            const sortedDisclaimers = fetchedDisclaimers.sort((a, b) => a.name.localeCompare(b.name));
            setDisclaimers(sortedDisclaimers);
            setOriginalDisclaimers(sortedDisclaimers);
            setDisclaimersSelected(selected)
        })

    }, [])

    function saveEdits() {
        // Save personnel records first
        // saveEditedPersonnel().then(() => {
        // Then save the fund
        console.log("Fund: ", fund)
        console.log("FundId: ", fundId);

        // return;
        
        remote.post(`funds/funds/static-data/${fundId}`, staticData).then(res => {
            remote.post(`/funds/funds/${fundId}/footnotes`, notes).then((notesResponse) => {
                const disclaimersIdsList = disclaimers.filter(d => d.selected).map(d => d.id).toString()
                if (disclaimersSelected.toString() !== disclaimersIdsList) {
                    remote.put(`/disclaimers/fund/${fundId}`, disclaimers).then(disclaimerResponse => {
                        const selected = disclaimerResponse && disclaimerResponse.length > 0 ? disclaimerResponse.filter(d => d.selected).map(d => d.id) : [];
                        const sortedResp = disclaimerResponse.sort((a, b) => a.name.localeCompare(b.name));
                        setDisclaimers(sortedResp);
                        setOriginalDisclaimers(sortedResp);
                        setDisclaimersSelected(selected)
                    }).catch(() => {
                        setDisclaimers(originalDisclaimers);
                    })
                }
                setNotes(notesResponse)
                setStaticData(res)
                setOriginalStaticData(res)
                setEditMode(false)
            })
            // });
            // setEditMode(false);
        }).then(() => {
            if (taggedNotesToDelete && taggedNotesToDelete.length > 0) untaggNotes()
            else toastSuccess("Changes saved");
        }).catch(error => {
            toastDanger("Failed to save changes");
            console.error("Failed to save personnel records:", error);
        });
    }

    function cancelEdits() {
        setStaticData(originalStaticData)
        setFund(originalFund)
        setNotes(originalFund.disclosures)
        setDisclaimers(originalDisclaimers)
        setCancelledChanges(true)
        setEditMode(false)
        setTimeout(() => {
            setCancelledChanges(false)
        }, 200);
    }

    function saveEditedPersonnel() {
        if (!originalFund || !fund) return Promise.resolve();

        const changedRecords = fund.personnel.filter((person, idx) => {
            const originalPerson = originalFund.personnel[idx];
            return JSON.stringify(person) !== JSON.stringify(originalPerson);
        });
        const updatePromises = changedRecords.map((person) => {
            return updatePersonnelRecord(person);
        });

        return Promise.all(updatePromises);
    }

    async function updatePersonnelRecord(person) {
        if (!person) return Promise.resolve();
        if (person.id === null) {
            await createNewPerson(person)
        } else if (person.deleted === true) {
            await deletePersonnelRecord(person)
        } else {
            await remote.put(`/funds/funds/personnel/${person.id}`, {
                name: person.name,
                currentPosition: person.currentPosition,
                currentStartDate: person.currentStartDate,
                previousPosition: person.previousPosition,
                previousStartDate: person.previousStartDate,
                previousEndDate: person.previousEndDate
            }).catch((error) => {
                console.error(`Failed to update personnel record for ${person.name}:`, error);
            });
        }
    }

    async function createNewPerson(person) {
        await remote.post("/funds/funds/personnel", {
            ...person,
            funds: [fundId]
        })
    }

    async function deletePersonnelRecord(person) {
        await remote.delete(`/funds/funds/personnel/${person.id}/fund/${fundId}`).then(() => {
            let newPersonnel = []
            fund.personnel.forEach((p) => {
                if (p.id !== person.id) {
                    newPersonnel.push(p)
                }
            })
            setFund({ ...fund, personnel: newPersonnel })
        })
    }

    const incompletePersonnelExists = fund?.personnel?.some(person => {
        return !person.name || !person.currentPosition || !person.currentStartDate || !person.previousPosition || !person.previousStartDate || !person.previousEndDate;
    });

    function untaggNotes() {
        const newNoteList = taggedNotes.filter(n => !taggedNotesToDelete.includes(n.offerNoteId))

        const footnoteIdToIndex = newNoteList.reduce((acc, item, index) => {
            acc[item.footnoteId] = index + 1;
            return acc;
        }, {});

        const sortedNotes = newNoteList
            .map(note => ({ ...note, superscript: footnoteIdToIndex[note.footnoteId] }))
            .sort((a, b) => a.superscript - b.superscript);

        const payload = { FOOTNOTES: JSON.stringify(sortedNotes) }

        if (templatesWithTaggedNotes.length > 0) {
            templatesWithTaggedNotes.forEach(template => {
                remote.put("/savev2/" + identifier + "/" + template, payload).then(response => {
                    setTaggedNotes(newNoteList)
                    setTaggedNotesIds(newNoteList.map(n => n.offerNoteId))
                    setTaggedNotesToDelete([])
                })
            })
        }
    }

    function changeTab(string) {
        if (!string) return
        if (string === "General") {
            return history.push(linkStem + ``)
        } else if (string === "Key Personnel") {
            return history.push(linkStem + `/personnel`)
        } else if (string === "Disclosures") {
            return history.push(linkStem + `/disclosures`)
        } else if (string === "Performance") {
            return history.push(linkStem + `/performance`)
        } else if (string === "Allocation") {
            return history.push(linkStem + `/allocation`)
        } else if (string === "Investment Mix") {
            return history.push(linkStem + `/investment-mix`)
        } else if (string === "Holdings") {
            return history.push(linkStem + `/holdings`)
        } else if (string === "Holdings Rationale") {
            return history.push(linkStem + `/holdings-rationale`)
        } else if (string === "Footnotes") {
            return history.push(linkStem + `/footnotes`)
        } else if (string === "Note Disclaimers") {
            return history.push(linkStem + `/disclaimers`)
        } else {
            return history.push(linkStem + `/${string}`)
        }
    }

    if (!fund) return (
        <Page noBanner>
            <PageContentBodyGrid id="fund-page" gridColCount="12" subGrid paddingBottom="2.5rem">
                <PageGridItem gap='l' direction='col' col="1 / span 12" >
                    <LoadingIcon centered />
                </PageGridItem>
            </PageContentBodyGrid>
        </Page>
    )

    const labels = [
        { label: "General", active: selectedTab === "General", onClick: () => changeTab("General") },
        { label: "Key Personnel", active: selectedTab === "Key Personnel", onClick: () => changeTab("Key Personnel") },
        { label: "Footnotes", active: selectedTab === "Footnotes", onClick: () => changeTab("Footnotes") },
        { label: "Performance", active: selectedTab === "Performance", onClick: () => changeTab("Performance") },
        { label: portfolio ? "Allocation" : "Investment Mix", active: portfolio ? selectedTab === "Allocation" : selectedTab === "Investment Mix", onClick: () => portfolio ? changeTab("Allocation") : changeTab("Investment Mix") },
        { label: "Holdings", active: selectedTab === "Holdings", onClick: () => changeTab("Holdings") },
        ...(portfolio ? [{ label: "Holdings Rationale", active: selectedTab === "Holdings Rationale", onClick: () => changeTab("Holdings Rationale") }] : []),
        { label: "Note Disclaimers", active: selectedTab === "Note Disclaimers", onClick: () => changeTab("Note Disclaimers") },
    ]

    nonGeneralConfigGroups.forEach(group => {
        labels.push(
            { label: group.groupName, active: selectedTab === group.groupName, onClick: () => changeTab(group.groupName) }
        )
    })

    return (
        <Page noBanner noOverflownY>
            <PageContentBodyGrid id="fund-page" gridColCount="12" subGrid paddingBottom="2.5rem">
                <PageGridItem gap='l' direction='col' col="1 / span 12" >
                    <ActionButtonsBanner
                        className="pt-l"
                        hideBackButton
                        editMode={editMode}
                        edit={{ onClick: () => setEditMode(true) }}
                        duplicate={{ disabled: true }}
                        remove={{ disabled: true }}
                        cancel={{ onClick: () => { cancelEdits() } }}
                        save={{ onClick: () => { saveEdits() } }}
                    />
                    <PageGridDivider />
                </PageGridItem>
                <PageGridItem gap='m' direction='col' col="1 / span 12" >
                    <PageContentToggle style={{ overflowX: 'auto', scrollbarWidth: 'none' }} labels={labels} />
                    <PageGridDivider />
                </PageGridItem>
                <PageGridItem direction='col' col="1 / span 12" style={{ overflowY: 'auto', height: "calc(100vh - 20.75rem)" }}>
                    <PageContentBodyGrid subGrid style={selectedTab === 'Holdings' || selectedTab === 'Allocation' ? { overflowY: 'hidden' } : null}>
                        <FundContext.Provider
                            value={{
                                fund: fund,
                                setFund: (val) => setFund(val),
                                originalFund: originalFund,
                                setOriginalFund: (val) => setOriginalFund(val),
                                editMode: editMode,
                                setEditMode: (boolean) => setEditMode(boolean),
                                selectedTab: selectedTab,
                                setSelectedTab: (val) => setSelectedTab(val),
                                taggedNotesToDelete: taggedNotesToDelete,
                                setTaggedNotesToDelete: (val) => setTaggedNotesToDelete(val),
                                notes: notes,
                                setNotes: (val) => setNotes(val),
                                taggedNotesIds: taggedNotesIds,
                                setTaggedNotesIds: (val) => setTaggedNotesIds(val),
                                setTaggedNotes: (val) => setTaggedNotes(val),
                                holdings: holdings,
                                staticData: staticData,
                                setStaticData: (val) => setStaticData(val),
                                originalStaticData: originalStaticData,
                                setOriginalStaticData: (val) => setOriginalStaticData(val),
                                config: config,
                                setConfig: (val) => setConfig(val),
                                brand: brand,
                                templatesWithTaggedNotes: templatesWithTaggedNotes,
                                setTemplatesWithTaggedNotes: (val) => setTemplatesWithTaggedNotes(val),
                                hierarchy: hierarchy,
                                disclaimers: disclaimers,
                                setDisclaimers: (val) => setDisclaimers(val),
                                portfolio: portfolio
                            }}
                        >
                            <Switch >
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/fund-management/funds/:fundId`} render={() => <FundGeneral name="Fund" />} />
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/fund-management/funds/:fundId/personnel`} render={() => <FundPersonnel />} />
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/fund-management/funds/:fundId/footnotes`} render={() => <FundFootnotes />} />
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/fund-management/funds/:fundId/performance`} render={() => <FundPerformance />} />
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/fund-management/funds/:fundId/investment-mix`} render={() => <FundInvestmentMix />} />
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/fund-management/funds/:fundId/holdings`} render={() => <FundHoldings />} />
                                {nonGeneralConfigGroups.map((group) => {
                                    return <Route 
                                    key={'fund-tab-' + group.groupName} exact 
                                    path={ROUTE_PATHS[PAGES.ADMIN] + `/fund-management/funds/:fundId/${group.groupName}`} 
                                    render={() => <FundTab group={group} name={group.groupName} cancelledChanges={cancelledChanges} />} />
                                })}
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/portfolio-management/portfolios/:fundId`} render={() => <FundGeneral portfolio name="Portfolio" />} />
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/portfolio-management/portfolios/:fundId/personnel`} render={() => <FundPersonnel portfolio />} />
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/portfolio-management/portfolios/:fundId/footnotes`} render={() => <FundFootnotes portfolio />} />
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/portfolio-management/portfolios/:fundId/disclaimers`} render={() => <FundDisclaimers portfolio />} />
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/portfolio-management/portfolios/:fundId/performance`} render={() => <FundPerformance portfolio />} />
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/portfolio-management/portfolios/:fundId/allocation`} render={() => <FundInvestmentMix portfolio />} />
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/portfolio-management/portfolios/:fundId/holdings`} render={() => <FundHoldings portfolio />} />
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/portfolio-management/portfolios/:fundId/holdings-rationale`} render={() => <FundHoldingRationales />} />
                                {nonGeneralConfigGroups.map((group) => {
                                    return <Route
                                        key={'portfolio-tab-' + group.groupName} exact
                                        path={ROUTE_PATHS[PAGES.ADMIN] + `/portfolio-management/portfolios/:fundId/${group.groupName}`}
                                        render={() => <FundTab group={group} name={group.groupName} cancelledChanges={cancelledChanges} />}
                                    />
                                })}
                            </Switch>
                        </FundContext.Provider>
                    </PageContentBodyGrid>
                </PageGridItem>
            </PageContentBodyGrid>
        </Page>
    )
}

export default FundPage;